export default __webpack_public_path__ + "static/media/unsplash_jessBailey_resume.fd7547f8.jpg";